const state = {
  currentPage: "",
  isLeftDrawerOpen: true,
  shoppingTabSelected: "All Items",
  shoppingCartTabSelected: "Draft",
  nonCartTabSelected: "Draft",
  blacklistTabSelected: "Blacklist Request",
  poNumber: "",
  pageSubtitle: "",
};

const getters = {
  currentPage: (state) => state.currentPage,
  isLeftDrawerOpen: (state) => state.isLeftDrawerOpen,
  shoppingTabSelected: (state) => state.shoppingTabSelected,
  shoppingCartTabSelected: (state) => state.shoppingCartTabSelected,
  nonCartTabSelected: (state) => state.nonCartTabSelected,
  blacklistTabSelected: (state) => state.blacklistTabSelected,
  poNumber: (state) => state.poNumber,
  pageSubtitle: (state) => state.pageSubtitle,
};

const mutations = {
  updateShoppingTabSelected(state, tabName) {
    state.shoppingTabSelected = tabName;
  },
  updateBlacklistTabSelected(state, tabName) {
    state.blacklistTabSelected = tabName;
  },
  resetShoppingTabSelected(state) {
    state.shoppingTabSelected = "All Items";
  },
  updateNonCartTabSelected(state, tabName) {
    state.nonCartTabSelected = tabName;
  },
  updateCurrentPage(state, pageName) {
    state.currentPage = pageName;
  },
  clearCurrentPage(state) {
    state.currentPage = "";
  },
  updateLeftDrawerState(state, bool) {
    state.isLeftDrawerOpen = bool;
  },
  updatePoNumber(state, number) {
    state.poNumber = number;
  },
  updatePageSubtitle(state, subTitle) {
    state.pageSubtitle = subTitle;
  },
};

const actions = {
  updateShoppingTabSelected({ commit }, tabName) {
    commit("updateShoppingTabSelected", tabName);
  },
  updateBlacklistTabSelected({ commit }, tabName) {
    commit("updateBlacklistTabSelected", tabName);
  },
  resetShoppingTabSelected({ commit }) {
    commit("resetShoppingTabSelected");
  },
  updateNonCartTabSelected({ commit }, tabName) {
    commit("updateNonCartTabSelected", tabName);
  },
  updateCurrentPage({ commit }, pageName) {
    commit("updateCurrentPage", pageName);
    commit("updatePageSubtitle", []);
  },
  clearCurrentPage({ commit }) {
    commit("clearCurrentPage");
    commit("updatePageSubtitle", []);
  },
  updateLeftDrawerState({ commit }, bool) {
    commit("updateLeftDrawerState", bool);
  },
  updatePoNumber({ commit }, number) {
    commit("updatePoNumber", number);
  },
  clearPoNumber({ commit }) {
    commit("updatePoNumber", "");
  },
  updatePageSubtitle({ commit }, subTitle) {
    commit("updatePageSubtitle", subTitle);
  },
};

export default { state, getters, mutations, actions };
